import React from 'react';
import { useRedirect } from '@common/hooks/useRedirect';
import { BrandName } from '@seek/je-shared-data/lib/types/brand';
import { JobStreetExpressLogo, JoraLogo } from '@components/Logo/logos';
import * as theme from '../../../../common/theme/theme';
import { useSetLocalisation } from './useLocalisation';
import { useSetAppPreference } from './useSetAppPreference';

export function useCountrySelected(brandName) {
  const { setAppPreference } = useSetAppPreference();
  const { setLocalisation } = useSetLocalisation();
  const { redirect } = useRedirect();

  return {
    handleCountrySelected: ({ country: countryCode }) => {
      setAppPreference(countryCode);
      setLocalisation(brandName, countryCode);
      redirect(`/${countryCode}/login`)();
    }
  };
}

export function useRedirectToLogin(countryCode) {
  const { redirect } = useRedirect();

  if (countryCode) {
    redirect(`/${countryCode}/login`)();
  }
}

export function useLogo() {
  return {
    getLogo: (brandName) => {
      switch (brandName) {
        case BrandName.JOBSTREETEXPRESS:
          return (
            <JobStreetExpressLogo
              testID="jobStreetExpressLogo"
              height={theme.gridRowHeight * 16}
              width={theme.gridRowHeight * 40}
              title={'JobStreet Express'}
            />
          );
        case BrandName.JORA:
        default:
          return (
            <JoraLogo
              testID="joraLogo"
              height={theme.gridRowHeight * 16}
              width={theme.gridRowHeight * 16}
              title={'Jora'}
            />
          );
      }
    }
  };
}
